import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectAccount } from '../../../features/auth/ducks';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../../../features/auth/api';
import { changePasswordRequest } from '../../../features/auth/ducks';
import UserSettings from '../components/UserSettings';
import NotificationSettings from '../components/NotificationSettings';
import DeviceList from '../components/DeviceList';
import PinChange from '../components/PinChange';
import { accountRoles } from '../../../common/enums';

const mapStateToProps = state => ({
  account: selectAccount(state),
  isChangingPassword: selectIsInProgress(state, apiCallIds.CHANGE_PASSWORD),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      changePassword: changePasswordRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class UserSettingsContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
    isChangingPassword: PropTypes.bool.isRequired,
  };

  onChangePassword = ({ passwordOld, password: passwordNew }) => {
    const { actions, account } = this.props;

    actions.changePassword({
      accountId: account.id,
      passwordOld,
      passwordNew,
    });
  };

  render() {
    const { isChangingPassword, account } = this.props;

    return (
      <div>
        <UserSettings
          isChangingPassword={isChangingPassword}
          account={account}
          onChangePassword={this.onChangePassword}
        />
        {account.role === accountRoles.CREDITOR &&
        <NotificationSettings
          account={account}
          />
        }
        <DeviceList />
        <PinChange />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-settings/containers/UserSettingsContainer.js